module.exports = __webpack_public_path__ + "static/img/coconut-pineapple-m.5a63125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/coconut-pineapple-m.jpg
// module id = TAGP
// module chunks = 0